if(typeof FN == 'undefined') FN = {};

FN.downloadLink = {
  selector: '.download-link, .button--start-trial',
  
  init: function() {
    $(window).on('click', FN.downloadLink.selector, function(event){
      event.preventDefault();
      var clickedElement = $(event.target);
      FN.downloadLink.startDownload(clickedElement);
    });
  },
  
  startDownload: function(clickedElement){
    if(!$(clickedElement).is('a')) return;
    
    var url = $(clickedElement).attr('href');
    
    // Check if this is a Windows download and if we need to add ARM architecture parameter
    FN.downloadLink.processDownloadURL(url)
      .then(function(processedUrl) {
        var iFrame = '<iframe style="display: none !important" src="'+ processedUrl +'">';
        $(iFrame).appendTo('body');
      })
      .catch(function(error) {
        console.warn('Download URL processing failed, using original URL:', error);
        var iFrame = '<iframe style="display: none !important" src="'+ url +'">';
        $(iFrame).appendTo('body');
      });
  },
  
  /**
   * Process download URL to add architecture parameters if needed
   * @param {string} url - Original download URL
   * @returns {Promise<string>} - Processed URL with architecture parameter if applicable
   */
  processDownloadURL: function(url) {
    // Check if this is a Windows download URL
    if (!FN.downloadLink.isWindowsDownloadURL(url)) {
      return Promise.resolve(url);
    }
    
    // Check if architecture detector is available
    if (!FN.architectureDetector || typeof FN.architectureDetector.detect !== 'function') {
      console.warn('Architecture detector not available, proceeding with standard download');
      return Promise.resolve(url);
    }
    
    return FN.architectureDetector.detect()
      .then(function(architecture) {
        // Only add parameter for ARM architecture
        if (architecture === 'arm') {
          return FN.downloadLink.addArchParameter(url, 'arm64');
        }
        
        return url;
      })
      .catch(function(error) {
        console.warn('Failed to detect architecture:', error);
        return url;
      });
  },
  
  /**
   * Check if URL is a Windows download URL
   * @param {string} url - URL to check
   * @returns {boolean} - True if this is a Windows download URL
   */
  isWindowsDownloadURL: function(url) {
    return url.indexOf('/download/windows') !== -1 || 
           url.indexOf('tower3-win') !== -1 ||
           url.indexOf('windows') !== -1;
  },
  
  /**
   * Add architecture parameter to download URL
   * @param {string} url - Original URL
   * @param {string} arch - Architecture parameter value (e.g., 'arm64')
   * @returns {string} - URL with architecture parameter added
   */
  addArchParameter: function(url, arch) {
    try {
      // Try modern URL API first
      if (typeof URL !== 'undefined' && URL.prototype.searchParams) {
        var urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set('arch', arch);
        return urlObj.toString();
      }
    } catch (error) {
      // Fall through to fallback method
    }
    
    // Fallback for browsers that don't support URL constructor
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + 'arch=' + encodeURIComponent(arch);
  },
  
  /**
   * Debug function to log architecture detection results
   * @returns {Promise<void>}
   */
  debugArchitecture: function() {
    if (!FN.architectureDetector) {
      console.log('Architecture detector not available');
      return Promise.resolve();
    }
    
    return FN.architectureDetector.detect()
      .then(function(architecture) {
        console.log('Detected architecture:', architecture);
        console.log('Is ARM:', architecture === 'arm');
        console.log('Is x86:', architecture === 'x86');
      })
      .catch(function(error) {
        console.error('Architecture detection failed:', error);
      });
  }
};

$(document).on('ready', function(){
  FN.downloadLink.init();
});